<template>
    <div class="content">
        <el-row :gutter="20">
            <el-col :span="6">
                <el-input v-model="content" size="small" clearable placeholder="请输入内容"></el-input>
            </el-col>
            <el-col :span="2">
                <el-button type="primary" size="small" icon="el-icon-search" @click="search">查询</el-button>
            </el-col>
            <el-col :span="2.5">
                <el-button type="success" size="small" icon="el-icon-add" @click="choosejoiner()">选择参与人员</el-button>
            </el-col>
            <el-col :span="2.5">
                <el-button type="primary" size="small" icon="el-icon-download" @click="download()" v-if="list.length>0">内容归档</el-button>
            </el-col>
            <el-col :span="6">
                <span style="font-size:14px" v-if="quanxian">
                    关闭协作
                </span>
                <el-switch
                  :value="is_together"
                  active-text=""
                  inactive-text=""
                  @change="changeXiezuo(is_together)"
                  v-if="quanxian">
                </el-switch>
                <span style="font-size:14px" v-if="quanxian">
                    开启协作
                </span>
            </el-col>
        </el-row>
        
        
        <my-form-item-group title="消息列表" style="margin-top:40px"></my-form-item-group>
        <el-card class="box-card">
            
            <div class="text item">
                <p style="text-align:center" v-if="list.length==0">暂无数据</p>
                <div v-else v-for="(item,index) in list" style="margin-bottom:20px" :key="index">
                    <el-row>
                        <el-col :span="20">发表人：{{item.create_name}}</el-col>
                        <el-col :span="4">{{item.create_time}}</el-col>
                    </el-row>
                    <div class="con">
                        <el-row style="margin-bottom:10px">
                            <el-col :span="2" style="font-weight:600;text-align:right">内容：</el-col>
                            <el-col :span="22">{{item.content}}</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2" style="font-weight:600;text-align:right">附件：</el-col>
                            <el-col :span="22">
                                <p v-for="list in item.fileList">
                                    <el-link 
                                        type="primary" 
                                        @click="down(list.rowguid)"
                                        :underline="false" 
                                        >
                                            {{list.filename}}
                                    </el-link>
                                </p>
                            </el-col>
                        </el-row>
                        
                    </div>
                </div>
            </div>
        </el-card>

        <my-form 
            class="form-page" 
            v-model="form" table 
            label-width="180px"
            style="margin-top:20px"
            :readonly="!is_together"
            @cancle="cancleHandler">
                <my-form-item-group title="填写内容">
                    <el-form-item label="模板下载" class="table-full-row" v-if="!~['5','7','9'].indexOf(ext3)">
                        <el-link 
                            type="primary"
                            class="downFile"
                            v-for="(item,index) in mbFileList"
                            :href="item.url"
                            :key="index">
                                {{item.name}}    
                        </el-link>
                    </el-form-item>
                    <el-form-item label="内容" class="table-full-row">
                        <el-input
                            type="textarea"
                            :rows="4"
                            placeholder="请输入内容"
                            v-model="form.content">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="文件上传" class="table-full-row">
                        <my-upload 
                            :file-size="100"
                            :file-guid="form.fileguid">
                        </my-upload>
                    </el-form-item>
                </my-form-item-group>
                <template slot="btn" slot-scope="scope">
                    <el-button type="primary" icon="el-icon-plus" @click="add()">
                        添加
                    </el-button>
                    <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
                </template>
        </my-form>
        <my-dialog 
        title="参与人员" 
        v-model="join_dialogVisible" 
        width="1200px"
        >
            <join-page 
                v-if="join_dialogVisible"
                :data="getQuery('procode')"
                @cancle="join_dialogClose"
            ></join-page>
        </my-dialog>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import JoinPage from './form'
export default {
    mixins: [FORM_PAGE_MIXIN],
    components: { 
        JoinPage
    },
    data() {
        return{
            list:[],
            content:'',
            form:{
                fileguid:'',
                procode:'',
                content:'',
            },
            fileList:[],
            filenameList:[],
            quanxian:false,
            join_dialogVisible:false,
            is_together:true,
            mbFileList:[
                {name:'招标文件模板',url:'/template/leibiemoban/招标文件模板.doc'},
            ],
            ext3:this.getQuery('ext3'),
        }
    },
    computed: {
        
    },
    watch: {
        
    },
    methods: {
        async changeXiezuo(value) {
            this.$confirm(`确认${!value ? '开启' : '关闭'}操作？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                this.is_together = !value
                var gbkqxz='0'
                if(this.is_together==true) {
                    gbkqxz='0'
                }else {
                    gbkqxz='1'
                }
                this.$post(`/Zbdl/collaboration/gbkqxz.json`, {
                    procode: this.getQuery('procode'),
                    gbkqxz :gbkqxz,
                },(data, res) => {
                    ShowMsg(`${!value ? '开启' : '关闭'}成功`,'success')
                })
            }).catch(() => {
                // this.$message.error('取消操作')
            })
        },
        getList(){
            var that = this;
            that.$get(`/Zbdl/collaboration/list.json`, {
                procode: that.getQuery('procode'),
                content:that.content,
            },(data, res) => {
                that.list = data;
                for(var i=0;i<data.length;i++) {
                    for(var j=0;j<data[i].fileList.length;j++) {
                        
                        this.fileList.push(data[i].fileList[j].realip+data[i].fileList[j].filesavepath.replace(/\\/g, "/"))
                        this.filenameList.push(data[i].fileList[j].filename)
                    }
                    // this.fileList.push(data[j].realip+data[j].filesavepath.replace(/\\/g, "/"))
                    // this.filenameList.push(data[j].filename)
                }
               
            })
        },
        getfileguid(){
            this.$get(`/standalonfile/operate/getfileguid.json`,(data, res) => {
                this.form.fileguid = data;
            })
        },
        choosejoiner() {
            this.join_dialogVisible=true
        },
        join_dialogClose() {
            this.join_dialogVisible=false
        },
        // 添加
        add(){
            this.fileList=[]
            this.filenameList=[]
            var that = this;
            that.form.content = that.form.content.trim();
            if(that.form.content==''){
                ShowMsg('请填写内容！','error');
                return
            }else{
                that.content = '';
                that.$post(`/Zbdl/collaboration/add.json`, that.form,(data, res) => {
                    ShowMsg('保存成功', 'success');     
                    that.form.content = '';
                    that.getList();
                    that.getfileguid();
                    
                })
            }
            
        },
        // 搜索
        search(){
            this.getList();
        },
        // 下载
        down(rowguid){
            window.open('/standalonfile/download/common.do?rowguid='+rowguid)
        },
        download() {
            // this.fileList=[]
            // this.filenameList=[]
            // this.getList()
            this.$post(`${this.getGetters('ageUrl')}/Zbdl/collaboration/savefj.json`, {
                fileurls:this.fileList.join(','),
                filenames:this.filenameList.join(','),
                procode:this.getQuery('procode')
            },(data, res) => {
                window.open(`${this.getGetters('ageUrl')}/Zbdl/collaboration/downloadzip?procode=`+this.getQuery('procode')); 
            })
        },
    },
    created() {
        this.getList();
        this.getfileguid();
        this.form.procode = this.getQuery('procode');
        //获取经办人+当前账号,判断是否一样，有无操作协作按钮权限
        this.$get(`/Zbdl/collaboration/jbzrrandcurrent.json`, {
            procode: this.getQuery('procode'),
        },(data, res) => {
            if(data.jbzrrcode==data.currentcode) {
                this.quanxian=true
            }
        })
        //获取项目协作的开启还是关闭
        this.$get(`/Zbdl/collaboration/getentrance.json`, {
            procode: this.getQuery('procode'),
        },(data, res) => {
             if(data.gbkqxz=='0'||data.gbkqxz==null) {
                this.is_together=true
            }else {
                this.is_together=false
            }
        })
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
    .content{ width: 1100px; margin: 30px auto; }
    /deep/ .el-card__header { padding: 10px 20px;}
    /deep/ .el-card__header span{ font-size: 14px; }
    .operation{ position: relative; }
    /deep/ .el-card{ font-size: 14px; max-height: 500px; overflow: auto; }
    /deep/ .el-card .con{ padding: 15px 20px; background-color: #F9FBFF; margin-top: 15px;}
    /deep/ .el-card .con p{ word-break: break-all; }
    /deep/ .el-textarea__inner{ padding: 10px 20px;}
    .downFile{ margin-right: 15px;}
</style>